function validaNumber(setRetorno, tamanho, valor) {
    if (valor.length <= tamanho) {
        if (valor.length === 1 && valor === ' ') {
            return;
        }
        let regexString = /^[0-9\b]+$/;
        if(regexString.test(valor) || valor === ''){
            setRetorno(valor);
        }       
    }
}

export default validaNumber;